<script lang="ts">
import { defineComponent } from 'vue';
import equal from 'fast-deep-equal';

export default defineComponent({
  name: 'TherapyCard',
  props: {
    therapy: { type: Object, required: true },
  },
  data() {
    return {
      doctorsSelectedAll: false,
      selectedDoctors: [],
    };
  },
  watch: {
    doctorsSelectedAll() {
      if (this.doctorsSelectedAll) {
        this.selectedDoctors = this.allDoctorsUUID;
      } else if (!this.doctorsSelectedAll && equal(this.selectedDoctors, this.allDoctorsUUID) ) {
        this.selectedDoctors = [];
      }
    },
    selectedDoctors() {
      this.doctorsSelectedAll = equal(this.selectedDoctors, this.allDoctorsUUID);

      this.$emit('update-doctors-list', {
        therapyUUID: this.therapy.therapyUUID,
        doctorsExternalIDs: this.selectedDoctors,
      });
    },
    therapy() {
      this.selectedDoctors = [];
      this.$emit('update-doctors-list', {
        therapyUUID: this.therapy.therapyUUID,
        doctorsExternalIDs: this.selectedDoctors,
      });
    },
  },
  computed: {
    allDoctorsUUID() {
      return this.therapy.doctors.map(({externalId}) => externalId);
    },
  },
  methods: {

  },
});
</script>

<template>
  <div class="">
    <div class="w-full mt-3">
      <h3 class="formTitle">THERAPY</h3>
      <span class="therapyNameBox block">{{ therapy.therapyName }}</span>
    </div>
    <div class="w-full">
      <h3 class="formTitle">DOCTORS</h3>
      <span class="my-1 mr-1 checkboxWrapper" style="background-color: #adadad">
        <v-checkbox
            v-model="doctorsSelectedAll"
            label="All"
            :value="true"
            hide-details
            density="compact"
            color="white"
            class="my-0 mx-0 doctorCheckbox"
        >
          <template v-slot:label>
              <span class="checkboxLabel">All</span>
            </template>
        </v-checkbox>
      </span>
      <span class="my-1 mr-1 checkboxWrapper defaultBgForCheckboxes" v-for="doctor in therapy.doctors" :key="doctor.externalId" :style="{backgroundColor: doctor.color}">
          <v-checkbox
              v-model="selectedDoctors"
              color="white"
              :label="$filters.initials(doctor.name)"
              :value="doctor.externalId"
              :title="doctor.name"
              hide-details
              density="compact"
              class="my-0 mx-0 doctorCheckbox"
          >
            <template v-slot:label>
              <span class="checkboxLabel">{{ doctor.name }}</span>
            </template>
          </v-checkbox>
        </span>
    </div>
  </div>
</template>

<style scoped>
.formTitle {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #adadad;
  text-transform: uppercase;
  margin: 5px 0;
}

.therapyNameBox {
  background: #ffffff;
  border-radius: 4px;
  padding: 4px 0;
}

.checkboxWrapper {
  display: inline-block;
  border-radius: 4px;
  padding: 3px 10px;
}

.checkboxWrapper > div {
  padding: 0 !important;
}

.checkboxLabel {
  color: #ffffff;
  font-weight: 400;
}

.defaultBgForCheckboxes {
  background-color: #4E8EB1;
}

.doctorCheckbox :deep(.v-selection-control) {
  min-height: auto;
}

.doctorCheckbox :deep(.v-selection-control__wrapper) {
  height: 24px;
  width: 24px;
}

.doctorCheckbox :deep(.v-icon) {
  color: white !important;
}
</style>
